var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttenderRank3(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "attender_rank_3_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 199
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.87 0H0v198.19h200.87V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#attender_rank_3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.335 38.295c-5.344-5.607-14.62-4.15-18.037 2.798-8.931 18.138-6.153 40.672 8.614 56.17 18.43 19.338 48.733 20.585 68.682 3.207L37.335 38.295z",
    fill: "#4C98A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 75.637C6.904 73.395-.438 79.237.024 86.962c1.201 20.181 14.762 38.401 35.266 44.593 25.586 7.726 52.554-6.134 61.31-31.085L14.323 75.637z",
    fill: "#338993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 121.798c-7.507 1.926-10.76 10.723-6.358 17.09 11.497 16.64 32.547 25.209 53.293 19.894 25.89-6.631 41.771-32.442 36.315-58.312l-42.55 10.898-40.706 10.424.006.006z",
    fill: "#197B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.535 38.295c5.344-5.607 14.621-4.15 18.037 2.798 8.931 18.138 6.154 40.672-8.614 56.17-18.43 19.338-48.734 20.585-68.682 3.207l59.259-62.175z",
    fill: "#4C98A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.548 75.637c7.419-2.242 14.762 3.6 14.304 11.33-1.201 20.181-14.761 38.401-35.266 44.594-25.586 7.726-52.554-6.134-61.31-31.085l82.272-24.84z",
    fill: "#338993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.526 121.798c7.507 1.926 10.76 10.723 6.359 17.09-11.498 16.64-32.548 25.209-53.293 19.894-25.89-6.631-41.771-32.442-36.316-58.312l42.551 10.898 40.705 10.424-.006.006z",
    fill: "#197B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.793 0H155.02c6.469 0 11.72 5.244 11.72 11.706v120.727c0 36.288-29.5 65.751-65.833 65.751-36.334 0-65.834-29.463-65.834-65.751V11.706C35.073 5.244 40.323 0 46.793 0z",
    fill: "#006C78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.196 67.49h75.415c4.507 0 8.169 3.651 8.169 8.158v49.346c0 25.29-20.557 45.816-45.873 45.816-25.322 0-45.874-20.532-45.874-45.816V75.648c0-4.5 3.657-8.159 8.17-8.159h-.007z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.611 69.83c3.212 0 5.825 2.61 5.825 5.818v49.346c0 23.973-19.526 43.475-43.529 43.475-24.004 0-43.53-19.502-43.53-43.475V75.648c0-3.207 2.614-5.818 5.825-5.818h75.415m0-2.34h-75.42c-4.513 0-8.17 3.651-8.17 8.158v49.346c0 25.302 20.54 45.816 45.874 45.816 25.333 0 45.873-20.514 45.873-45.816V75.648c0-4.507-3.656-8.159-8.169-8.159h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.02 0h-44.983L35.073 74.87v51.581L160.376 1.299A11.676 11.676 0 00155.02 0zM95.714 112.2l71.026-70.937v-29.23L81.081 97.586 95.714 112.2z",
    fill: "#fff",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttenderRank3);
export default ForwardRef;